import * as Yup from 'yup'

import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import React from 'react'
import SimpleAutocomplete from 'components/common/SimpleAutocomplete/SimpleAutocomplete'
import SimpleInput from 'components/common/SimpleInput/SimpleInput'
import UserSettingTab from 'components/common/UserSettingTab/UserSettingTab'
import clsx from 'clsx'
import { useForm } from 'hooks/use-form'
import { useStyles } from './styles'

const validationSchema = Yup.object().shape({
    displayName: Yup.string()
        .max(25, 'Display Name should be shorter than 25 characters')
        .required('Please, provide a display name'),
    location: Yup.string().required('Please, provide a location'),
})

const Profile = ({ cities, retrieveCities, user, updateUserProfile, userError, userSuccess }) => {
    const classes = useStyles()
    const { values, handleSubmit, eventHandlers, valueHandlers, errors, touched, changed } = useForm(
        'profile',
        { displayName: user.displayName || '', location: user.location || '' },
        updateUserProfile,
        validationSchema,
    )

    const userMessage = userSuccess === true ? 'User sucessfully updated' : userSuccess === false ? userError : ''

    return (
        <UserSettingTab title="Profile Information">
            <div className={classes.profilePicContainer}>
                <div className={classes.profilePic}></div>
                <div className={classes.profilePicPanel}>
                    <CallToActionButton className={classes.editButton} type="default" text={'Edit Photo'} />
                    <div className={classes.editMessage}>Must be JPEG or PNG and cannot exceed 10MB.</div>
                </div>
            </div>
            <form onSubmit={handleSubmit}>
                <SimpleInput
                    error={touched.displayName && errors.displayName}
                    onChange={eventHandlers.displayName}
                    value={values.displayName}
                    label="Display Name"
                    tooltipText="This is how you’ll appear on Novel"
                    maxLength={25}
                />
                <SimpleAutocomplete
                    error={touched.location && errors.location}
                    onSelect={valueHandlers.location}
                    initialValue={values.location}
                    options={cities.map(city => city.name)}
                    filterOptions={retrieveCities}
                    label="Where are you based?"
                    name="location"
                    type="location"
                />
                <div className={classes.submit}>
                    <CallToActionButton
                        onClick={handleSubmit}
                        className={classes.editButton}
                        type={!changed.form ? 'disabled' : 'primary'}
                        text={'Save'}
                    />
                    {
                        <div
                            className={clsx({
                                [classes.message]: true,
                                [classes.error]: userSuccess === false,
                                [classes.success]: userSuccess === true,
                            })}
                        >
                            {userMessage}
                        </div>
                    }
                </div>
                <input style={{ display: 'none' }} type="submit" />
            </form>
        </UserSettingTab>
    )
}

export default React.memo(Profile)
